//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     Plan
//   Details:    Plan component
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
//  84474 26/09/19 JC  M01  Need to URI encode the site
// 105066 06/01/20 JC  M02  Added font awesome
// 105927 11/02/20 JC  M03  Added bank holiday days
// 104762 02/03/20 JC  M04  M02 still using bsSize rather than size for font awesome
// WI2470 20/01/23 JC  M05JC	Rename/re-sequence of holiday details
//-------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { history } from '../history';
import { Col, Row } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { weeksActions } from '../store/Weeks';
import { connect } from 'react-redux';
//M02 import { Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //M02
import './css/Plan.css';

class Plan extends Component {
	constructor(props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick = event => {
		event.preventDefault();
		const { site, siteId } = this.props.item;
        history.push(`/myplan/site/${siteId}/${encodeURIComponent(site)}`);//M01
	}

	toDecimal = (x) => Number.parseFloat(x).toFixed(2);

	render() {
		const { item } = this.props;
		return (
			<a className="plan-item" onClick={this.handleClick}>
				<div className="page-item-row">
					<div className="text-col">
						<h5>{item.site} {item.holidayYear}</h5>
						<Row>
							<Col sm={6}> {/*M05JC changed from xs to get under holiday when on very small screens*/}
								<h6>Holiday</h6>
								<table>
									<tbody>
										{/* M05JC re-written below
											<tr>
												<td>Entitlement</td>
												<td className="align-right">{this.toDecimal(item.holEntitlementDays)}</td>
											</tr>
											<tr>
												M03 bank holiday count
												<td>Bank holiday</td>
												<td className="align-right">{this.toDecimal(item.bankHolidayDays)}</td>
											</tr>
											<tr>
												<td>Used</td>
												<td className="align-right">{this.toDecimal(item.holUsedDays)}</td>
											</tr>
											<tr>
												<td>Approved</td>
												<td className="align-right">{this.toDecimal(item.holApprovedDays)}</td>
											</tr>
											<tr>
												<td>Remaining</td>
												<td className="align-right">{this.toDecimal(item.holRemainingDays)}</td>
											</tr>
											<tr>
												<td>Pending</td>
												<td className="align-right">{this.toDecimal(item.holRequestedDays)}</td>
										</tr>
										*/}

										{/*M05JC...*/}
										<tr>
											<td>Overall entitlement</td>
											<td className="align-right">{this.toDecimal(item.holEntitlementDays)}</td>
										</tr>
										<tr>
											{/* M03 bank holiday count */}
											<td>Bank holidays remaining</td>
											<td className="align-right">{this.toDecimal(item.bankHolidayDays)}</td>
										</tr>
										<tr>
											<td>Holiday taken</td>
											<td className="align-right">{this.toDecimal(item.holUsedDays)}</td>
										</tr>
										<tr>
											<td>Holiday booked (approved)</td>
											<td className="align-right">{this.toDecimal(item.holApprovedDays)}</td>
										</tr>
										<tr>
											<td>Holiday booked (pending)</td>
											<td className="align-right">{this.toDecimal(item.holRequestedDays)}</td>
										</tr>
										<tr>
											<td>Holiday outstanding</td>
											<td className="align-right">{this.toDecimal(item.holRemainingDays)}</td>
										</tr>

									</tbody>
								</table>
							</Col>
							<Col sm={6}> {/*M05JC changed from xs to get under holiday when on very small screens*/}
								<h6>Absence</h6>
								<table>
									<tbody>
										<tr>
											<td>Used</td>
											<td className="align-right">{this.toDecimal(item.absUsedDays)}</td>
										</tr>
										<tr>
											<td>Approved</td>
											<td className="align-right">{this.toDecimal(item.absApprovedDays)}</td>
										</tr>
										<tr>
											<td>Pending</td>
											<td className="align-right">{this.toDecimal(item.absRequestedDays)}</td>
										</tr>
									</tbody>
								</table>
							</Col>
						</Row>
					</div>
					<div className="chevron-col">
                        <FontAwesomeIcon icon="chevron-right" size="lg" /> {/* M02 M04 */}
					</div>
				</div>
			</a>
		);
	}
}

Plan.propTypes = {
	item: PropTypes.shape({
		id: PropTypes.number.isRequired,
		siteId: PropTypes.number.isRequired,
		site: PropTypes.string.isRequired,
		contractTask: PropTypes.string.isRequired,
		holidayYear: PropTypes.string.isRequired,
		holEntitlementDays: PropTypes.number.isRequired,
		holUsedDays: PropTypes.number.isRequired,
		holApprovedDays: PropTypes.number.isRequired,
		holRemainingDays: PropTypes.number.isRequired,
		holRequestedDays: PropTypes.number.isRequired,
		absUsedDays: PropTypes.number.isRequired,
		absApprovedDays: PropTypes.number.isRequired,
		absRequestedDays: PropTypes.number.isRequired
	})
};

export default connect(
	state => state,
	dispatch => bindActionCreators(weeksActions, dispatch)
)(Plan);
